import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL hash
      const hash = location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

      if (!sessionId) {
        toast.error("No session ID found");
        navigate('/auth');
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/callback`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const { user, access_token } = response.data;
        
        // Update auth state
        localStorage.setItem('token', access_token); // Keep JWT compatibility
        localStorage.setItem('user', JSON.stringify(user));
        setUser(user);

        toast.success(`Welcome back, ${user.name}!`);
        navigate('/marketplace');
      } catch (error) {
        console.error("Auth error", error);
        toast.error("Authentication failed");
        navigate('/auth');
      }
    };

    processAuth();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-xl font-bold text-stone-900">Completing Secure Login...</h2>
      </div>
    </div>
  );
}
